@if (isVisible) {
<nav role='navigation' aria-label='breadcrumb'>
	<div class='breadcrumb'>
		@for (breadcrumb of breadcrumbs; track $index; let last = $last) {
		@if(breadcrumb.label === 'BREADCRUMBS.HOME'){
		<a class="pointer" (click)="goToLink(breadcrumb)"><img class='home-icon' src='/assets/icons/icon_home.svg' /></a>
		}
		@else {
		<a class="pointer" (click)="goToLink(breadcrumb)">{{ breadcrumb.label | translate}}</a>
		}

		@if (!last) {
		<span class="separator">/</span>
		}
		}
	</div>
</nav>
}